import { getCurrentSession } from '../lib/auth.ts';
import { applyTenantRequestHeaders } from '../lib/tenantRequestContext';

const DEMO_PREFERENCES_KEY = 'demo-mode-preferences';

async function buildPreferenceHeaders(): Promise<Record<string, string> | null> {
  const session = await getCurrentSession();
  const userId = String(session?.user?.id || '').trim();
  if (!userId) return null;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'x-user-id': userId,
  };

  const accessToken = String(session?.access_token || '').trim();
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

  return applyTenantRequestHeaders(headers);
}

export async function fetchDemoModePreference(): Promise<boolean> {
  try {
    const headers = await buildPreferenceHeaders();
    if (!headers) return false;

    // Use absolute URL mapping context for API endpoints
    const res = await fetch(`/api/user-preferences/${DEMO_PREFERENCES_KEY}`, {
      headers,
    });
    if (!res.ok) return false;

    const data = await res.json().catch(() => null);
    return data?.value?.demoModeDisabled === true;
  } catch (err) {
    console.error('Failed to fetch demo mode preference:', err);
    return false;
  }
}

export async function saveDemoModePreference(demoModeDisabled: boolean): Promise<boolean> {
  try {
    const headers = await buildPreferenceHeaders();
    if (!headers) return false;

    const res = await fetch(`/api/user-preferences/${DEMO_PREFERENCES_KEY}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ demoModeDisabled }),
    });
    return res.ok;
  } catch (err) {
    console.error('Failed to save demo mode preference:', err);
    return false;
  }
}
